import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { medium } from "core/fontStyles";
import breakpoints from "core/breakpoints";

const OptionLabelStyled = styled.div`
    display: flex;
    align-items: center;
`;
const DisplayTextStyled = styled.div`
    ${medium}
    margin-left: ${convertPxToRem(4)};
`;
const DisplayTextStyledHideText = styled(DisplayTextStyled)`
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        display: none;
    }
`;

// component
export const OptionLabel = ({ text, Icon, hideTextOnMobile = false }) => {
    const DisplayText = hideTextOnMobile
        ? DisplayTextStyledHideText
        : DisplayTextStyled;

    return (
        <OptionLabelStyled title={text}>
            <Icon
                size={{ height: 16, width: 16 }}
                fillColor={colors.secondary.orca}
            />
            <DisplayText>{text}</DisplayText>
        </OptionLabelStyled>
    );
};

export default OptionLabel;

// prop-types
OptionLabel.propTypes = {
    text: PropTypes.string.isRequired,
    Icon: PropTypes.any.isRequired,
    hideTextOnMobile: PropTypes.bool
};
